<template>
  <span>
    <b-dropdown v-if="isSubscriptionEvent === false" v-model="paymentMethod" aria-role="list">
      <button slot="trigger" class="button is-light" type="button">
        <!-- invoice -->
        <template v-if="paymentMethod == 'invoice'">
          <b-icon icon="file-document-outline" />
          <span>{{ $t("paymentMethod__invoice") }}</span>
        </template>
        <!-- mandate -->
        <template v-else-if="paymentMethod && typeof paymentMethod.id !== 'undefined' && paymentMethod.details">
          <img
            class="icon mr-2"
            style="width: 24px"
            :src="`/assets/card-labels/${paymentMethod.details.cardLabel.toLowerCase()}.svg`"
          />
          <span
            >{{ paymentMethod.details.cardLabel }} - **** {{ paymentMethod.details.cardNumber }} -
            {{ paymentMethod.details.cardHolder }}</span
          >
        </template>
        <!-- else -->
        <template v-else>
          <b-icon icon="credit-card-outline" />
          <span>{{ $t("choosePaymentMethod") }}</span>
        </template>
        <b-icon icon="menu-down" />
      </button>
      <b-dropdown-item
        v-if="this.$store.state.organizationData.approvedForPaymentOnInvoice && !isSubscriptionBooking"
        :value="'invoice'"
        aria-role="listitem"
      >
        <div class="media">
          <b-icon class="media-left" icon="file-document-outline" />
          <div class="media-content">
            <h3>{{ $t("paymentMethod__invoice") }}</h3>
            <small>{{ $t("paymentMethod__invoiceShortDesc") }}</small>
          </div>
        </div>
      </b-dropdown-item>
      <!-- <b-dropdown-item :value="'inAdvance'" aria-role="listitem">
      <div class="media">
        <b-icon class="media-left" icon="file-document-outline" />
        <div class="media-content">
          <h3>{{ $t("paymentMethod__inAdvance") }}</h3>
          <small>{{ $t("paymentMethod__inAdvanceShortDesc") }}</small>
        </div>
      </div>
      </b-dropdown-item> -->
      <b-dropdown-item v-for="mandate in mandates" :key="mandate.id" :value="mandate" aria-role="listitem">
        <div class="media">
          <div class="media-left">
            <img
              style="width: 24px; margin-top: 4px"
              :src="`/assets/card-labels/${mandate.details.cardLabel.toLowerCase()}.svg`"
            />
          </div>
          <div class="media-content">
            <h3>
              **** {{ mandate.details.cardNumber }} -
              {{ mandate.details.cardHolder }}
            </h3>
            <small>{{ mandate.details.cardLabel }} - {{ mandate.details.cardHolder }}</small>
          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-item :value="'addCreditCard'" aria-role="listitem">
        <div class="media">
          <b-icon class="media-left" icon="credit-card-plus" />
          <div class="media-content">
            <h3>{{ $t("paymentMethod__addCreditCard") }}</h3>
            <small>{{ $t("paymentMethod__addCreditCardShortDesc") }}</small>
          </div>
        </div>
      </b-dropdown-item>
    </b-dropdown>
    <button v-else class="button is-light" type="button">
      <b-icon class="has-text-warning" icon="crown" size="is-small" />
      <span>{{ $t("qondaSubscriber") }}</span>
    </button>
  </span>
</template>

<script>
import { db, functions } from "@/firebase";

export default {
  name: "PaymentTypePicker",
  props: {
    organizationId: {
      type: String,
      default: "",
    },
    isSubscriptionEvent: {
      type: Boolean,
      default: false,
    },
    isSubscriptionBooking: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mandates: [],
      paymentMethod: "",
      isLoading: false,
      paymentWindow: null,
      mandateIndex: [],
    };
  },
  computed: {
    mandatesCollection() {
      return db.collection("organizations").doc(this.organizationId).collection("mandates");
    },
  },
  watch: {
    paymentMethod: {
      immediate: true,
      async handler(method, oldMethod) {
        console.log("watcher fired", method);
        this.$emit("selectedPaymentMethod", method);
        if (method == "addCreditCard") {
          await this.createCreditCardMandate();
          this.paymentMethod = oldMethod;
        }
      },
    },
    mandates(mandates) {
      if (this.paymentWindow && mandates.find((x) => !this.mandateIndex.includes(x.id))) {
        this.paymentMethod = mandates.find((x) => !this.mandateIndex.includes(x.id));
      }
      this.mandateIndex = mandates.map((m) => m.id);
      if (this.paymentWindow) {
        this.paymentWindow.close();
        this.paymentWindow = null;
      }
    },
  },
  mounted() {
    this.$watch("organizationId", () => {
      this.$bind("mandates", this.mandatesCollection);
    });
  },
  methods: {
    async createCreditCardMandate() {
      this.addLoading = true;
      try {
        let { data } = await functions.httpsCallable("MollieFirstPayment")({
          organizationId: this.organizationId,
          closeAfter: true,
        });
        this.addLoading = false;
        this.paymentWindow = window.open(data.checkoutUrl, "payment", "width=450,height=700");
      } catch (error) {
        this.addLoading = false;
        this.$buefy.toast.open({
          duration: 5000,
          message: error.toString(),
          type: "is-danger",
        });
      }
    },
  },
  firestore() {
    return {
      mandates: this.mandatesCollection,
    };
  },
};
</script>
